<template>
    <div>
         <!-- Contenido principal -->
            <main class="layoutContent">
                <!-- Encabezado contenido principal -->
                <header class="page-header">
                    <div class="container pt-2">
                        <div class="row align-items-center justify-content-between">
                            <div class="col-auto pt-1">
                                <h1 class="page-header--title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                        <path
                                            d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                                        <path
                                            d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    Solicitud VERANO
                                </h1>
                                <p class="page-header--subtitle">
                                    Plan de vacaciones
                                </p>
                            </div>
                            <div class="col-12 col-xl-auto mt-2"></div>
                        </div>
                    </div>
                </header>
                <!-- Fin encabezado contenido principal -->

                <!-- Cuerpo contenido principal -->
                <div class="container content-body">
                    <div class="row">
                        <!-- Bloque Personas-->
                        <div class="col-xl-3 mb-1">
                            <div class="card">
                                <div class="card-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>
                                    Estado
                                </div>
                                <div class="card-body">

                                    <div class="form-group">
                                        <label for="numSolicitud">Número Solicitud</label>
                                        <input disabled class="form-control" type="text" v-model="SOL.id"/>
                                        <!-- <b-icon button class="h2" icon="cancel-circle-fill" variant="danger"></b-icon> -->

                                    </div>
                                    <div class="form-group">
                                        <label>Fecha</label>
                                        <input disabled class="form-control" type="text" v-model="SOL.fecha"/>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <label for="personas">Personas</label>
                                            <input disabled class="form-control" type="text" v-model="SOL.pax"/>
                                        </div>
                                        <div class="form-group col">
                                            <label for="personas">Adultos</label>
                                            <input disabled class="form-control" type="text" v-model="SOL.adu"/>
                                        </div>
                                        <div class="form-group col">
                                            <label for="personas">Niños</label>
                                            <input disabled class="form-control" type="text" v-model="SOL.nin"/>
                                        </div>
                                    </div>

                                    <h3 class="font-weight-bold text-center mt-3" :style="estilo_estado">
                                        {{ SOL.estado }}
                                    </h3>
                                    <div class="mt-3 text-center" v-show="SOL.std<=1">
                                        <!-- <b-button-group size="sm"> -->
                                            <b-button size="sm" variant="outline-info" @click="editar">
                                                <b-icon icon="pencil-square"></b-icon> Editar
                                            </b-button>
                                            <b-button class="ml-1" size="sm" variant="outline-info" @click="pdf">
                                                <b-icon icon="printer-fill"></b-icon> PDF
                                            </b-button>
                                            <!-- <br> -->
                                            <b-button class="mt-1 ml-1" size="sm" variant="outline-danger" @click="anular">
                                                <b-icon icon="x-circle"></b-icon> Anular
                                            </b-button>
                                        <!-- </b-button-group> -->

                                        <!-- <b-button variant="danger" size="sm" class="mb-2">
                                            <b-icon icon="x-circle" variant="light" aria-hidden="true"></b-icon>Anular
                                        </b-button>                                -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Bloque Establecimientos y Observaciones -->
                        <div class="col-xl-9 mb-2">
                            <div class="card mb-2">
                                <div class="card-header">Establecimientos</div>
                                <div class="card-body">
                                    <!-- 1 -->
                                    <div class="accommodation mb-2">
                                        <div class="form-group row">
                                            <label for="establecimiento"
                                                class="col-sm-2 col-form-label col-form-label-sm">Establecimiento</label>
                                            <div class="col-sm-10">
                                                <input disabled type="text" class="form-control" v-model="SOL.s1hotel" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="periodo" class="col-sm-2 col-form-label col-form-label-sm">Periodo / Tipo</label>
                                            <div class="col-sm-3">
                                                <input disabled type="text" class="form-control" v-model="SOL.s1per" />
                                            </div>
                                            <div class="col-sm-3">
                                                <input disabled type="text" class="form-control" v-model="SOL.s1t"/>
                                            </div>
                                             <label for="periodo" class="col-sm-1 col-form-label col-form-label-sm">Hab.</label>
                                            <div class="col-sm-2">
                                                <input disabled type="text" class="form-control" v-model="SOL.s1h1"/>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 1 -->
                                    <div class="accommodation mb-2">
                                        <div class="form-group row">
                                            <label for="establecimiento"
                                                class="col-sm-2 col-form-label col-form-label-sm">Establecimiento</label>
                                            <div class="col-sm-10">
                                                <input disabled type="text" class="form-control" v-model="SOL.s2hotel" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="periodo" class="col-sm-2 col-form-label col-form-label-sm">Periodo / Tipo</label>
                                            <div class="col-sm-3">
                                                <input disabled type="text" class="form-control" v-model="SOL.s2per" />
                                            </div>
                                            <div class="col-sm-3">
                                                <input disabled type="text" class="form-control" v-model="SOL.s2t"/>
                                            </div>
                                             <label for="periodo" class="col-sm-1 col-form-label col-form-label-sm">Hab.</label>
                                            <div class="col-sm-2">
                                                <input disabled type="text" class="form-control" v-model="SOL.s2h1"/>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 1 -->
                                    <div class="accommodation mb-2">
                                        <div class="form-group row">
                                            <label for="establecimiento"
                                                class="col-sm-2 col-form-label col-form-label-sm">Establecimiento</label>
                                            <div class="col-sm-10">
                                                <input disabled type="text" class="form-control" v-model="SOL.s3hotel" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="periodo" class="col-sm-2 col-form-label col-form-label-sm">Periodo / Tipo</label>
                                            <div class="col-sm-3">
                                                <input disabled type="text" class="form-control" v-model="SOL.s3per" />
                                            </div>
                                            <div class="col-sm-3">
                                                <input disabled type="text" class="form-control" v-model="SOL.s3t"/>
                                            </div>
                                             <label for="periodo" class="col-sm-1 col-form-label col-form-label-sm">Hab.</label>
                                            <div class="col-sm-2">
                                                <input disabled type="text" class="form-control" v-model="SOL.s3h1"/>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">Observaciones</div>
                                <div class="card-body">
                                     <textarea disabled class="mx-1 my-1 form-control" cols="30" rows="2" v-model="SOL.sobs"/>
                                    <p><small>
                                        Para acceso a Solicitudes ADJUDICADAS o en RESERVA vea
                                        Menú Reservas. Desde ese apartado podrá ver e imprimir la
                                        documentación de la misma. En caso de NO ADJUDICADA o
                                        CANDELADA, deberá ir a VACANTES para ver los
                                        establecimientos y periodos disponibles.</small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Fin Cuerpo contenido principal -->
            </main>

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'solicitud_verano',

  props: {
        datos: { type:Object, default: null},
    },

  data() {
    return {
        modulo: 'SOLICITUDES',

    }
  },

  created() {
  },

  mounted() {
  },

  computed: {
    ...mapState(['auth','SOL','G']),

    logueado() {
        return this.auth.logueado;
    },
    usuario() {
        return this.$store.state.auth.user;
    },

    estilo_estado() {
        let a=['black','blue','green','red'];
        return "color: " + a[this.SOL.std];
    }

  },

  methods: {
       ...mapMutations(['loading','alerta','modal']),
       ...mapActions(['exec']),

       async anular() {
            let msg="Estas Seguro <b>ANULAR</b> Solicitud ?<br>Se eliminaran los establecimientos seleccionados";
            let r=await this.$root.$msgConf(msg,'SOLICITUD VERANO');
            if (!r) return;

            var args={ token: this.auth.token, fnt:'anular', id: this.SOL.id }
            r=await this.exec({api:'solicitud', arg: args });

            if (!r.error)
                r.datos='Solicitud ANULADA';

            //guardamos datos
            this.modal({tit:"SOLICITUD VERANO", msg: r.datos});
            this.$router.push('/');
        },

        editar() {
            //this.$parent.editamos=true;
            this.$emit('edicion');

            this.$router.push('/solicitar-verano');
        },

        async pdf() {
            var args={ token: this.auth.token, fnt: 'pdf', id: this.SOL.id }
            let r=await this.exec({api:'solicitud', arg: args });

            if (r.error) {
                this.modal({tit: this.modulo, msg: r.datos});
                return;
            }
            let url=this.G.url_tmpW + r.datos;
            window.open(url,'blank');
        },

   }

}
</script>